import React from 'react'
import { Container, Card, FilledButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import EmployerGrid from 'components/EmployerGrid'
import Loading from 'components/Loading'
import { withRouter } from 'react-router-dom'
import { VisibilityFilters } from 'actions'
import WarningIcon from 'assets/images/ln-icon-warning-exclamation.svg'
import api from '../../utils/api'

class ManageEmployers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      employers: [],
      allEmployers: [],
      isExternalUser: this.props.isExternalUser,
      showAddDomainBanner: false,
      hasLoadedEmployer: false,
      hasEmployers: false,
      hasErrorLoadingEmployers: false
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.handleActiveFilter = this.handleActiveFilter.bind(this)
    this.handleAddEmployer = this.handleAddEmployer.bind(this)
  }

  componentWillMount() {
    
    this.getData(this.props.showActiveOnly)
  }

  getData(showActiveOnly) {
    if(this.state.allEmployers.length !== 0) { return }
    const apiCall = api.getAllEmployers
    this.setState({ hasLoadedEmployer: false })
    apiCall()
      .then((data) => {
        if(data.length > 0) {
          data.forEach(emp => {
            if ((emp.allowedDomains === null || emp.allowedDomains === undefined) && emp.active === true) {
              this.setState({ showAddDomainBanner: true })
              return
            }
          })
        }
        this.setState({ 
          allEmployers: data,
          employers: showActiveOnly ? data.filter((employer) => employer.active === true) : data,
          hasEmployers: Object.keys(data).length > 0,
          hasLoadedEmployer: true,
          hasErrorLoadingEmployers: false
        })
      })
      .catch(() => {
        this.setState({
          employers: [],
          allEmployers: [],
          hasLoadedEmployer: true,
          hasErrorLoadingEmployers: true
        })
      })
  }

  getFilteredEmployers(showActiveOnly) {
    if(showActiveOnly) {
      this.setState({
        employers: this.state.allEmployers.filter((employer) => employer.active === true )
      })
    }
    else {
      this.setState({
        employers: this.state.allEmployers
      })
    }
  }

  handleSelect(employer) {
    this.props.history.push(`/employers/${employer.id}#tab-details`)
  }

  handleActiveFilter() {
    // Invert the visibility filter based on the original showActiveOnly setting.
    const showActiveOnly = !this.props.showActiveOnly
    this.props.setEmployerActiveFilter(showActiveOnly ? VisibilityFilters.SHOW_ACTIVE : VisibilityFilters.SHOW_ALL)
    this.getFilteredEmployers(showActiveOnly)
  }

  handleAddEmployer() {
    this.props.history.push('/employers/add#tab-details')
  }

  render() {

    return (
      <div className="ln-c-header-body ln-u-soft-top" id="main-content">
        <Container soft>
          <div className="ln-u-soft-left ln-u-1/2@sm">
            <h3 className="companies">Companies</h3>
          </div>
          {this.state.showAddDomainBanner &&
            <Card className="card ln-o-generic--margin-bottom u-left-border yellow">
              <div className="ln-o-flag u-height__3rem">
                <div className="ln-o-flag__component">
                  <svg className="ln-icon-warning-exclamation ln-c-modal-alert-icon-alignment-sm" role="presentation" viewBox="0 0 50 50">
                    <use xlinkHref={`#${WarningIcon.id}`} />
                  </svg>
                </div>
                <div className="ln-o-flag__body">
                  <p className="u-margin-bottom__zero">Please add authorised email domains to your companies&nbsp;
                    <b>to allow for colleagues to register automatically</b>
                  </p>
                </div>
              </div>
            </Card>
          }
          <Card className="card">
            <div className="ln-o-grid ln-o-generic--margin-bottom">
              <div className="ln-o-grid__item ln-u-1/2@sm">
                { this.state.isExternalUser ? '' : <FilledButton
                  id="cmdAddEmployer"
                  className="ln-c-button ln-c-button--primary ln-u-1/2@md ln-u-1/2@sm"
                  onClick={this.handleAddEmployer}
                  disabled={!this.state.hasLoadedEmployer || this.state.hasErrorLoadingEmployers}
                > Add a new company 
                </FilledButton>
                }
              </div>
              <div className="ln-o-grid__item ln-u-1/2@sm">
                <div className="ln-c-form-option--checkbox u-right-align-sm">
                  <input
                    className="ln-c-form-option__input"
                    id="chkShowInactive"
                    type="checkbox"
                    defaultChecked={!this.props.showActiveOnly}
                    onChange={this.handleActiveFilter}
                  />
                  <label className="ln-c-form-option__label inactiveCompanies" htmlFor="chkShowInactive">Show inactive companies</label>
                </div>
              </div>
            </div>
            { !this.state.hasLoadedEmployer && 
              <Loading title="Loading Companies" />
            }
            { this.state.hasLoadedEmployer && 
            <div>
              <EmployerGrid 
                employers={this.state.employers} 
                onSelect={this.handleSelect} 
                hasError={this.state.hasErrorLoadingEmployers}
                hasEmployers={this.state.hasEmployers}
              />
            </div>
            }
          </Card>
        </Container>
      </div>
    )
  }
}

ManageEmployers.propTypes = {
  showActiveOnly: PropTypes.bool.isRequired,
  setEmployerActiveFilter: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  isExternalUser: PropTypes.bool.isRequired
}

export default withRouter(ManageEmployers)


// WEBPACK FOOTER //
// ./src/components/ManageEmployers/ManageEmployers.jsx